import { useEffect, useCallback, useMemo } from "react";
import { Select, SelectProps } from "antd";
import { useRequest } from "../../hooks";
import { getOrgs } from "../../api/organization";

const cached: { current: null | PagedData<Orgnization> } = {
    current: null
};

type Option = {
    value: string, label: string, disabled?: boolean,
}

export default function LocaltionSelect(p: SelectProps & {
    onOptionChange?: (options: Option[]) => void,
    plain?: boolean,
    optionsFormatter?: (options?: Option[]) => Option[],
}) {
    const optionsFormatter = p.optionsFormatter || (_ => _);
    const fetchData = useCallback(async () => {
        cached.current = cached.current || await getOrgs({ pageNum: 1, pageSize: 1000 });
        return cached.current;
    }, [])
    const { data, loading } = useRequest(fetchData);
    const locations = useMemo(() => data?.data.map(i => {
        return {
            value: i.organizationId,
            label: i.name
        }
    }), [data])
    useEffect(() => {
        p.onOptionChange?.(locations || [])
    }, [locations, p.onOptionChange])
    return p.plain ? <span>{locations?.find(i => i.value === p.value)?.label}</span> : (
        <Select
            style={{ minWidth: 100 }}
            placeholder={'请选择展馆'}
            options={optionsFormatter(locations)}
            {...p}
            loading={loading || p.loading}
        />
    )
}